"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var Avatar_1 = __importDefault(require("@material-ui/core/Avatar"));
var styles_1 = require("../../styles");
var useStyles = (0, styles_1.makeStyles)(function (_a) {
    var spacing = _a.spacing, typography = _a.typography;
    return ({
        extraSmall: {
            width: spacing(2),
            height: spacing(2),
            fontSize: '0.5rem'
        },
        small: {
            width: spacing(3),
            height: spacing(3),
            fontSize: typography.caption.fontSize
        },
        large: {
            width: spacing(7),
            height: spacing(7),
        }
    });
});
var Avatar = function (_a) {
    var _b;
    var _c = _a.classes, classes = _c === void 0 ? {} : _c, alt = _a.alt, children = _a.children, imgProps = _a.imgProps, sizes = _a.sizes, src = _a.src, srcSet = _a.srcSet, _d = _a.variant, variant = _d === void 0 ? 'circle' : _d, _e = _a.size, size = _e === void 0 ? 'medium' : _e;
    var internalClasses = useStyles();
    return (react_1.default.createElement(Avatar_1.default, { classes: __assign(__assign({}, classes), { root: (0, classnames_1.default)((_b = {},
                _b[classes.root || ''] = true,
                _b[internalClasses.extraSmall] = size === 'extra-small',
                _b[internalClasses.small] = size === 'small',
                _b[internalClasses.large] = size === 'large',
                _b)) }), alt: alt, imgProps: imgProps, sizes: sizes, src: src, srcSet: srcSet, variant: variant }, children));
};
exports.default = Avatar;
